module.exports = __webpack_public_path__ + "static/img/login.d4d5f382.png";